module.exports = "pegasus/assets/responsive.png";